<template>
  <div class="faculty">
    <tabs v-if="isReady">
      <tab name="Genel">
        <div class="row">
          <div class="col-md-12">
            <div class="widget">
              <div class="form-elements-sec">
                <div class="widget-title">
                  <h3>
                    Fakülte Düzenle
                    <small>( {{ name }} )</small>
                  </h3>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="university">Üniversite</label>
                      <select class="form-control custom-input" v-model="university">
                        <option
                          v-for="university in universities"
                          :key="university.id"
                          :value="university.id"
                        >{{ university.name }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="name">Fakülte Adı</label>
                      <input type="text" v-model="name" class="form-control custom-input">
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </tab>
      <tab name="Listeleme">
        <div class="row">
          <div class="col-md-12">
            <div class="widget">
              <div class="form-elements-sec">
                <div class="widget-title">
                  <h3>İlçe Düzenle ({{ name }})</h3>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="title">Başlık</label>
                      <input class="form-control custom-input" v-model="title">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="keywords">Meta Keywords</label>
                      <textarea class="form-control custom-input" v-model="keywords" rows="5"></textarea>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="description">Meta Description</label>
                      <textarea class="form-control custom-input" v-model="description" rows="5"></textarea>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="spot">Spot</label>
                      <vue-editor :editorToolbar="customToolbar" v-model="spot" class="editor"></vue-editor>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="list_seo">İlçe Description</label>
                      <vue-editor :editorToolbar="customToolbar" v-model="list_seo" class="editor"></vue-editor>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </tab>
      <tab name="Erkek Öğr. SEO">
        <div class="row">
          <div class="col-md-12">
            <div class="widget">
              <div class="form-elements-sec">
                <div class="widget-title">
                  <h3>İlçe Düzenle ({{ name }})</h3>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="male_title">Başlık</label>
                      <input class="form-control custom-input" v-model="male_title">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="male_keywords">Meta Keywords</label>
                      <textarea class="form-control custom-input" v-model="male_keywords" rows="5"></textarea>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="male_description">Meta Description</label>
                      <textarea
                        class="form-control custom-input"
                        v-model="male_description"
                        rows="5"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="male_spot">Spot</label>
                      <vue-editor :editorToolbar="customToolbar" v-model="male_spot" class="editor"></vue-editor>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </tab>
      <tab name="Kız Öğr. SEO">
        <div class="row">
          <div class="col-md-12">
            <div class="widget">
              <div class="form-elements-sec">
                <div class="widget-title">
                  <h3>İlçe Düzenle ({{ name }})</h3>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="female_title">Başlık</label>
                      <input class="form-control custom-input" v-model="female_title">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="female_keywords">Meta Keywords</label>
                      <textarea
                        class="form-control custom-input"
                        v-model="female_keywords"
                        rows="5"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="female_description">Meta Description</label>
                      <textarea
                        class="form-control custom-input"
                        v-model="female_description"
                        rows="5"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="female_spot">Spot</label>
                      <vue-editor :editorToolbar="customToolbar" v-model="female_spot" class="editor"></vue-editor>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </tab>
    </tabs>
    <div class="row">
      <div class="col-md-12">
        <div class="widget text-center">
          <div class="form-elements-sec">
            <button class="btn btn-success" @click="updateData">Kaydet</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { VueEditor } from "vue2-editor";
export default {
  components: { VueEditor },

  data() {
    return {
      isReady: false,
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }]
      ],
      id: this.$route.params.id,
      name: "",
      university: "",
      universities: [],
      api: "faculties/",
      title: "",
      keywords: "",
      description: "",
      spot: "",
      content: "",
      list_seo: "",
      male_title: "",
      male_keywords: "",
      male_description: "",
      male_spot: "",
      female_title: "",
      female_keywords: "",
      female_description: "",
      female_spot: ""
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$Progress.start();
      this.axios.get(this.api + this.id + "/edit").then(response => {
        this.name = response.data.faculty.name;
        this.university = response.data.faculty.university_id;
        this.universities = response.data.universities;
        this.title = response.data.title;
        this.list_seo = response.data.list_seo;
        this.male_title = response.data.male_title;
        this.male_keywords = response.data.male_keywords;
        this.male_description = response.data.male_description;
        this.male_spot = response.data.male_spot;
        this.female_title = response.data.female_title;
        this.female_keywords = response.data.female_keywords;
        this.female_description = response.data.female_description;
        this.female_spot = response.data.female_spot;
        this.$Progress.finish();
      }).then(() => {
        this.isReady = true;
      });
    },
    updateData() {
      this.$Progress.start();
      this.axios
        .put(this.api + this.id, {
          university: this.university,
          name: this.name,
          title: this.title,
          keywords: this.keywords,
          description: this.description,
          content: this.content,
          list_seo: this.list_seo,
          male_title: this.male_title,
          male_keywords: this.male_keywords,
          male_description: this.male_description,
          male_spot: this.male_spot,
          female_title: this.female_title,
          female_keywords: this.female_keywords,
          female_description: this.female_description,
          female_spot: this.female_spot
        })
        .then(response => {
          this.$Progress.finish();
        });
    }
  }
};
</script>

<style scoped>
</style>
